var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _path2, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLinter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 80,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.644,
    cy: 16.2475,
    r: 1.57949,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.828,
    cy: 38.151,
    r: 0.934211,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.934211,
    cy: 26.7994,
    r: 0.934211,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5953,
    cy: 62.5934,
    r: 0.934211,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8698,
    cy: 10.4191,
    r: 0.934211,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.352,
    cy: 42.2975,
    r: 0.934211,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7174,
    cy: 10.4191,
    r: 0.934211,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7174,
    cy: 6.43421,
    r: 0.934211,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.22891,
    cy: 73.1103,
    r: 1.57949,
    fill: "currentColor"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.7617,
    cy: 37.413,
    r: 3.79096,
    fill: "currentColor"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.209,
    cy: 13.2758,
    r: 3.79096,
    fill: "currentColor"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.557,
    cy: 68.4206,
    r: 2.5764,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.2764 12.7451C87.1219 12.7451 93.3481 13.5267 98.4844 14.9473C103.642 16.3738 107.599 18.4164 110.017 20.8613L110.019 20.8633C112.097 22.9544 113.598 26.5279 114.495 30.7754C115.384 34.9849 115.643 39.6819 115.378 43.8398L115.377 43.8584C115.265 46.152 114.937 49.322 114.082 52.3623C113.219 55.4301 111.867 58.1952 109.826 59.8701L109.817 59.8779C107.072 62.1727 102.776 63.9767 97.5732 65.2012C92.3952 66.4197 86.4302 67.0381 80.4473 67.0381C74.4647 67.0381 68.5064 66.4199 63.3135 65.2012C58.2613 64.0154 54.0313 62.2834 51.1924 60.0811L50.9219 59.8662C48.8732 58.1939 47.5351 55.4276 46.6748 52.3496C45.9286 49.6798 45.5773 46.9103 45.3877 44.707L45.3164 43.7988C45.0951 39.5848 45.3842 34.9021 46.2754 30.7197C47.148 26.6245 48.5639 23.1701 50.498 21.0537L50.6875 20.8525C53.0933 18.4239 57.0132 16.3857 62.1309 14.958C67.2344 13.5343 73.4316 12.7451 80.2764 12.7451Z",
    stroke: "currentColor",
    strokeWidth: 2.49049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4574,
    cy: 37.9843,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.54391
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3616,
    cy: 45.8689,
    r: 1.68295,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.61508
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3609,
    cy: 62.8043,
    r: 4.67154,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.61508
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.282,
    cy: 51.846,
    r: 1.68295,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.61508
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.388,
    cy: 21.9602,
    r: 1.68295,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.61508
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.8278,
    cy: 29.8107,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.8082,
    cy: 32.358,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8053,
    cy: 27.3771,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.7858,
    cy: 38.3356,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.7633,
    cy: 52.2819,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.7516,
    cy: 43.316,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.7819,
    cy: 19.4078,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.736,
    cy: 35.3468,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.7711,
    cy: 31.3619,
    r: 0.80754,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.253342
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.025 63.4502L65.8545 29.1714",
    stroke: "currentColor",
    strokeWidth: 2.49049,
    strokeLinecap: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 80,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.644,
    cy: 16.2475,
    r: 1.57949,
    fill: "currentColor"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.828,
    cy: 38.151,
    r: 0.934211,
    fill: "currentColor"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.934211,
    cy: 26.7994,
    r: 0.934211,
    fill: "currentColor"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5953,
    cy: 62.5934,
    r: 0.934211,
    fill: "currentColor"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8698,
    cy: 10.4191,
    r: 0.934211,
    fill: "currentColor"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.352,
    cy: 42.2975,
    r: 0.934211,
    fill: "currentColor"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7174,
    cy: 10.4191,
    r: 0.934211,
    fill: "currentColor"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7174,
    cy: 6.43421,
    r: 0.934211,
    fill: "currentColor"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.22891,
    cy: 73.1103,
    r: 1.57949,
    fill: "currentColor"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.7617,
    cy: 37.413,
    r: 3.79096,
    fill: "currentColor"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.209,
    cy: 13.2758,
    r: 3.79096,
    fill: "currentColor"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.557,
    cy: 68.4206,
    r: 2.5764,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.2764 12.7451C87.1219 12.7451 93.3481 13.5267 98.4844 14.9473C103.642 16.3738 107.599 18.4164 110.017 20.8613L110.019 20.8633C112.097 22.9544 113.598 26.5279 114.495 30.7754C115.384 34.9849 115.643 39.6819 115.378 43.8398L115.377 43.8584C115.265 46.152 114.937 49.322 114.082 52.3623C113.219 55.4301 111.867 58.1952 109.826 59.8701L109.817 59.8779C107.072 62.1727 102.776 63.9767 97.5732 65.2012C92.3952 66.4197 86.4302 67.0381 80.4473 67.0381C74.4647 67.0381 68.5064 66.4199 63.3135 65.2012C58.2613 64.0154 54.0313 62.2834 51.1924 60.0811L50.9219 59.8662C48.8732 58.1939 47.5351 55.4276 46.6748 52.3496C45.9286 49.6798 45.5773 46.9103 45.3877 44.707L45.3164 43.7988C45.0951 39.5848 45.3842 34.9021 46.2754 30.7197C47.148 26.6245 48.5639 23.1701 50.498 21.0537L50.6875 20.8525C53.0933 18.4239 57.0132 16.3857 62.1309 14.958C67.2344 13.5343 73.4316 12.7451 80.2764 12.7451Z",
    stroke: stroke,
    strokeWidth: 2.49049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.4574,
    cy: 37.9843,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.54391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.3616,
    cy: 45.8689,
    r: 1.68295,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.61508
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.3609,
    cy: 62.8043,
    r: 4.67154,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.61508
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.282,
    cy: 51.846,
    r: 1.68295,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.61508
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.388,
    cy: 21.9602,
    r: 1.68295,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.61508
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.8278,
    cy: 29.8107,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.8082,
    cy: 32.358,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.8053,
    cy: 27.3771,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.7858,
    cy: 38.3356,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.7633,
    cy: 52.2819,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.7516,
    cy: 43.316,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.7819,
    cy: 19.4078,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.736,
    cy: 35.3468,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7711,
    cy: 31.3619,
    r: 0.80754,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 0.253342
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.025 63.4502L65.8545 29.1714",
    stroke: stroke,
    strokeWidth: 2.49049,
    strokeLinecap: "round"
  }));
});
export default SvgIconLinter;
export const raw = __webpack_public_path__ + "static/media/icon-linter.85a125342fa04f5ef1f361c4465e43fa.svg";